<div class="container-auth">
  <mat-icon
    matPrefix
    class="auth-step"
    *ngIf="!showGreenIconAuth"
    (click)="goToAuth()"
  >
    panorama_fish_eye
  </mat-icon>
  <mat-icon
    matPrefix
    class="auth-step"
    *ngIf="showGreenIconAuth"
    (click)="goToAuth()"
  >
    brightness_1
  </mat-icon>
  <hr class="auth-hr" />
  <p class="auth-p">
    Autenticación
  </p>
</div>
<div class="container-payment">
  <mat-icon
    matPrefix
    class="payment-step-green"
    (click)="goToPayment()"
    *ngIf="showGreenOutlineIconPayment"
  >
    panorama_fish_eye
  </mat-icon>
  <mat-icon
    matPrefix
    class="payment-step-green"
    (click)="goToPayment()"
    *ngIf="showGreenIconPayment"
  >
    brightness_1
  </mat-icon>
  <mat-icon matPrefix class="payment-step" *ngIf="showGrayIconPayment">
    brightness_1
  </mat-icon>
  <hr class="payment-hr" />
  <p class="payment-p" *ngIf="!activeTitleStepPayment">
    Pago
  </p>
  <p class="payment-p-black" *ngIf="activeTitleStepPayment">
    Pago
  </p>
</div>
<div class="container-confirmation">
  <mat-icon
    matPrefix
    class="confirmation-step-green"
    *ngIf="showGreenOutlineIconConfirmation"
  >
    panorama_fish_eye
  </mat-icon>
  <mat-icon
    class
    class="confirmation-step"
    matPrefix
    *ngIf="showGrayIconConfirmation"
  >
    brightness_1
  </mat-icon>
  <p class="confirmation-p" *ngIf="!activeTitleStepConfirmPayment">
    Confirmación
  </p>
  <p class="confirmation-p-black" *ngIf="activeTitleStepConfirmPayment">
    Confirmación
  </p>
</div>
